(function() {
	"use strict";

	angular
		.module("sempraWebapp")
		.controller("ManagingTokensController", managingTokensController);

	/** @ngInject */
	function managingTokensController(
		ManagingTokensViewModel,
		$scope,
		$mdDialog,
		$document,
		managingTokensActions,
		$log,
		inputValidationService
	) {
		var vm = this;

		vm.managingTokens = new ManagingTokensViewModel();

		vm.refresh = function() {
			vm.promise = managingTokensActions
				.getManagingTokens(vm.managingTokens.selectedUser)
				.then(
					function(data) {
						vm.managingTokens.refresh(data);
					},
					function(errorData) {
						$log.log("An error occurred" + errorData);
					}
				);
		};

		vm.userSelected = function(email) {
			vm.managingTokens.selectedUser = email;
			vm.managingTokens.isUserSelected = true;
			vm.refresh();
		};

		vm.tokensDetails = function(ev, tokensData, edit) {
			$mdDialog.show({
				controller: deleteAndExtendTokenController,
				controllerAs: "vm",
				bindToController: true,
				templateUrl: "app/managingTokens/deleteAndExtendTokensModal.html",
				parent: angular.element($document.body),
				targetEvent: ev,
				locals: {
					tokenData: tokensData,
					edit: edit,
					vm: vm
				},
				clickOutsideToClose: true
			});
		};

		init();

		function init() {
			$scope.$on("$destroy", destroy);
		}

		function destroy() {
			vm.managingTokens.destroy();
		}

		// Delete and extend tokens controller
		function deleteAndExtendTokenController(tokenData, edit, vm, $translate) {
			/* eslint-disable */
			var that = this;
			/* eslint-enable */

			that.amount = 0;
			that.companyName = tokenData.companyDefaultCurrency;
			that.expirationDate = new Date(tokenData.expirationDate);
			that.edit = edit;
			that.amountNotValid = false;
      that.dialogTitle = edit ? $translate.instant('EXTEND_TOKEN_DATE') : $translate.instant('DELETE_TOKENS_FOR');

			that.saveChanges = function(form) {
				var dataToSave = {
					accountId: tokenData.accountId
				};
				if (edit) {
					dataToSave.timestamp = form.expirationDate.$modelValue.getTime();
					managingTokensActions.extendManagingTokens(dataToSave).then(
						function() {
							vm.refresh();
						}
					);
          that.closeDialog();
				} else {
          dataToSave.amount = form.amount.$modelValue;
					managingTokensActions.deleteManagingTokens(dataToSave).then(
						function() {
							vm.refresh();
						}
					);
          that.closeDialog();
				}
			};

			that.inputValidation = function(amount) {
				that.amountNotValid = inputValidationService.singleNumberOnly(amount);
			}

			that.closeDialog = function() {
				$mdDialog.hide();
			};
		}
	}
})();
